import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getPlugins, getPlugin } from '../index';
export const useGetPlugins = (additionlInfo) => useQuery(['GetPluginDescriptionList', additionlInfo], () => trackPromise(getPlugins(additionlInfo)), {
    cacheTime: 0
});
export const useGetPlugin = (additionlInfo) => useQuery(['GetPluginByGuid', additionlInfo], () => trackPromise(getPlugin(additionlInfo)), {
    cacheTime: 0
});
